
export default function Chat() {
    const urlCIP = process.env.REACT_APP_URL_CIP;
    return <iframe title='Chat Instituçional Publico' src={urlCIP} width={'100%'} height={'94%'} style={{ border: 'none', background: '#fff', marginTop: 5, borderRadius: 5 }} />
}
